import { amber, red, purple, lightGreen, blue, teal } from '@material-ui/core/colors';
import { Grid, Paper, Tooltip, Typography } from '@material-ui/core';
import { useCompanyMaster, useSnackbarInstance } from '@lib/common';
import { useCallback, useMemo, useState } from 'react';
import { CompanyMasters } from '@api/masters';
import { Column } from 'react-table';
import { DraggableRowsTable } from '@components/draggable-rows-table';
import { ColoredChipIconButton, ColoredChip } from '@components/colored-elements';
import { ImDrawer2, TrashFill } from '@icon/react-icons';
import { createContextQuick } from '@components/quick-context';
import { ServicesPicker } from './ServicesPicker_v4';
import { TypesContainer } from '../company-types';
import { createFormField } from '../../common';
import getLoadingMessage from '@lib/common/loading-messages';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import { Row } from '@material-ui/data-grid';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  Button,
  Chip,
  Link
} from '@material-ui/core';
import LaunchIcon from '@material-ui/icons/Launch';
import { Skeleton } from '@material-ui/lab';

export const ServicesLoader = ({ value = null, onChange = null, similarClick = null, isLock = true, edit = false }) => {
  const { master: services, loading } = useCompanyMaster('services');
  //console.log("values",value)
  const filteredServices = useMemo(() => {
    if (value && value.length && services && services.length) {
      return services.filter(s => !value.find(v => v.id === s.id));
    }
    return services;
  }, [value, services]);

  const { enqueue } = useSnackbarInstance();

  const onServiceAdd = useCallback(
    (srvs: CompanyMasters.Service[]) => {
      onChange(srvs);
    },
    [value, onChange]
  );

  const onServiceDelete = (srv: CompanyMasters.Service) => {
    if (value && onChange) {
      const idx = value.findIndex(v => v.id === srv.id);
      if (idx >= 0) {
        const nextValue = [...value];
        nextValue.splice(idx, 1);
        onChange(nextValue);
      }
    }
  };
  const ServiceColumn: Column<CompanyMasters.Service>[] = useMemo(
    () => [
      {
        Header: '#',
        id: 'serial',
        accessor: (_row, idx) => idx + 1,
        width: 35,
      },
      {
        Header: 'Service',
        id: 'service',
        accessor: row => row.service,
        width: 200,
      },
      {
        Header: 'Ultimate Parent',
        id: 'ultimate_parent',
        accessor: row =>
          row.ultimate_parent == null ? (
            <Skeleton variant="text" width={120} />
          ) : (
            row.ultimate_parent || '-'
          ),
        width: 200,
      },
     {
        Header: 'Hierarchy Level',
        id: 'hierarchy_level',
        accessor: row =>
          row.hierarchy_level == null ? (
            <Skeleton variant="text" width={60} />
          ) : (
            row.hierarchy_level ?? '-'
          ),
        width: 200,
      },
      {
        Header: 'Status',
        id: 'status',
        // /accessor: (_row, idx) => idx + 1,
        accessor: (_row, idx) => {
        
          if (idx + 1 == 1) {
            return (
              <Tooltip title="Primary Service">
                <span>
                  <ColoredChip colored={blue[700]} label="Primary" />
                </span>
              </Tooltip>
            );
          } else {
            return (
              <>
                <Tooltip title="Secondary Services">
                  <span>
                    <ColoredChip colored={teal[700]} label="Secondary" />
                  </span>
                </Tooltip>
              </>
            );
          }
        },
        width: 35,
      },
      
      {
        Header: 'Attributes #',
        id: 'attributes_count',
        accessor: row => (row.attributes_count ?
          <Tooltip title="Visit Relation">
                  <Chip
                    size="small"
                    component={Link}
                    target="_blank"
                    href={`${window.location.origin}/company-service/${row.company_vtr_id}/edit/${row.relation_vtr_id}`}
                    icon={<LaunchIcon />}
                    label={`${row.attributes_count}`}
                    clickable
                    color="primary"
                  />
                </Tooltip>
          
           : 0 ),
        width: 200,
      },
      {
        Header: 'Action',
        id: 'actions',
        width: 80,
        Cell({ row }) {
        
          const { deleteService, onSimilarClick = null } = useDeleteService();
          const onDeleteClick = () => deleteService(row.original);
          const simillarClick = onSimilarClick && (() => onSimilarClick(row.original));
          const [openConfirmationBox, setOpenConfirmationBox] = useState(false)
          return (
            <>
              <Tooltip title="Delete">
                <span>
                  <ColoredChipIconButton
                    onClick={()=>{(row.original.attributes_count && row.original.attributes_count > 0) ? setOpenConfirmationBox(true) : onDeleteClick()}}
                    disabled={isLock}
                    pointer
                    colored={red[900]}
                    size="small"
                    icon={<TrashFill />}
                  />
                </span>
              </Tooltip>
              <Dialog
                open={openConfirmationBox}
                onClose={()=>setOpenConfirmationBox(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                  Service Attribute attached, are you sure you want to remove Base Service?
                </DialogTitle>
                <DialogActions>
                  <Button onClick={()=>setOpenConfirmationBox(false)} color="primary">
                    Cancel
                  </Button>
                  <Button onClick={() => {onDeleteClick(), setOpenConfirmationBox(false)}} color="primary" autoFocus>
                    Ok
                  </Button>
                </DialogActions>
              </Dialog>
              {simillarClick && (
                <>
                  &nbsp;
                  <Tooltip title="Show Similar Service">
                    <span>
                      <ColoredChipIconButton
                        disabled={isLock}
                        onClick={simillarClick}
                        pointer
                        colored={amber[900]}
                        size="small"
                        icon={<EmojiObjectsIcon />}
                      />
                    </span>
                  </Tooltip>
                </>
              )}
            </>
          );
        },
      },
    ],
    [isLock]
  );
  return (
    <TypesContainer>
      <Grid container spacing={4} justify="center" alignItems="center">
        <Grid item>
          <Typography variant="h6" style={{ fontSize: 16 }}>
            Manage Services
          </Typography>
        </Grid>
        <Grid item xs />
        <Grid item>
          {!loading && services && (
            <ServicesPicker
              services={filteredServices}
              onServiceAdd={onServiceAdd}
              defaultSelected={value}
              isLock={isLock}
              edit={edit}
            />
          )}
          {loading && (
            <Typography variant="body2" color="textSecondary">
              {getLoadingMessage()}
            </Typography>
          )}
        </Grid>
      </Grid>
      {value && value.length ? (
        <Paper className="fixed-height">
          <ProvideDelete deleteService={onServiceDelete} onSimilarClick={similarClick}>
            <DraggableRowsTable
              getRowId={getServiceRowId}
              onChange={onChange}
              columns={ServiceColumn}
              data={value}
              stickyHeader
              size="small"
            />
          </ProvideDelete>
        </Paper>
      ) : (
        EmptyContent
      )}
    </TypesContainer>
  );
};

const EmptyContent = (
  <Paper className="fixed-height no-data">
    <span>
      <ImDrawer2 />
      <br />
      <Typography>
        Click on <strong>Add</strong> button
        <br />
        and start managing services.
      </Typography>
    </span>
  </Paper>
);

const [ProvideDelete, useDeleteService] = createContextQuick<{
  deleteService: (srv: CompanyMasters.Service) => any;
  onSimilarClick?: (srv: CompanyMasters.Service) => any;
}>();
const getServiceRowId = row => row.id;


export function ServiceMasterDialog({
  serviceMasterId,
  deleteServiceMaster = false,
  onDeleteFinish = null,
  onCloseConfirmation = null,
  openConfirmationBox,
}) {
  return deleteServiceMaster ? (
    <Dialog
      open={openConfirmationBox}
      onClose={onCloseConfirmation}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
      Service Attribute attached, are you sure you want to remove Base Service?
      </DialogTitle>
      <DialogActions>
        <Button onClick={onCloseConfirmation} color="primary">
          Cancel
        </Button>
        <Button onClick={() => onDeleteFinish(serviceMasterId)} color="primary" autoFocus>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
}


export const CompanyServiceField = createFormField(ServicesLoader, {
  defaultValue: [],
  passProps: true,
});
